import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { LabMDM } from "../masterdata/models/lab";
import { BBResponseContainer } from "../carrier/response-container";
import { Subject } from "rxjs";
import { PrintRequest } from "../carrier/print-request";
import { Container } from "../container-view/models/container";
import { timeout, tap } from 'rxjs/operators';

/**
 * @description Angular Service to interact with Sample Reception service
 * to get a carrier information based on barcode or createdDate.
 */
@Injectable()
export class CarrierSearchService {


    constructor(private http: HttpClient) { 
        
    }

    /**
     * @description Find Carrier by barcode.
     * @param barcode 
    */
    searchContainerByBarcode(barcode: string, lab: LabMDM): Observable<BBResponseContainer> {
        
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'container';
        let requestParam = new HttpParams()
                                .set('labId', lab._id)
                                .set('barcode', barcode);
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

      /**
     * @description Find Container Data by barcode and LabId.
     * @param barcode 
    */
   getContainerDataByBarcode(barcode: string, lab: LabMDM): Observable<BBResponseContainer> {
        
    let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'container/containerdata';
    let requestParam = new HttpParams()
                            .set('labId', lab._id)
                            .set('barcode', barcode);
    const options = url ? { params: requestParam } : {};

    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
}

    /**
     * @description Find Carrier by creation date.
     * @param startDate 
     * @param pageNo 
     */
    searchBySampleCreationDate(startDate: string, pageNo: number, lab: LabMDM, processStep: string, processState: string, selectedWellType:string): Observable<BBResponseContainer> {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'container/list';
        let requestParam = new HttpParams()
                                .set('labId', lab._id)
                                .set('startPage', pageNo.toString())
                                .set('fromDate', startDate)
                                .set('dateOperator', "eq")
                                .set('processStep', processStep)
                                .set('processState', processState)
                                .set('wellType',selectedWellType);

        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    /**
     * @description Get count of total carrier based on Base Condition(Lab, creation date)
     * @param startDate 
    */
    getCarriersCount(startDate: string, lab: LabMDM, processStep: string, processState: string, selectedWellType:string): Observable<BBResponseContainer> {
        
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL +  'container/count' ;
        let requestParam = new HttpParams()
                                .set('labId', lab._id)
                                .set('fromDate', startDate)
                                .set('dateOperator', "eq")
                                .set('processStep', processStep)
                                .set('processState', processState)
                                .set('wellType',selectedWellType);
        const options = url ? { params: requestParam } : {};

        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
    }

    //shared Methods
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) {
        console.log("emit change");
        this.emitChangeSource.next(change);
    }


    public reprintLabel(printRequest: PrintRequest): Observable<BBResponseContainer> {
        let url = environment.BB_PRINT_SERVICE_URL + 'printLabel';
        return this.http.post<BBResponseContainer>(url, printRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    public reExport(container: Container): Observable<BBResponseContainer> {
        console.log("Carrier on search-> reExport" , container);
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'generateControllerFile';
        return this.http.post<BBResponseContainer>(url, container).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));

    }

    getContainerById(id: string) {
        let url = environment.BB_SAMPLE_RECEPTION_SERVICE_URL + 'container/' + id;
        return this.http.get<BBResponseContainer>(url).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
            error.url = url;
        }));
    }

    //Gets a list of process Steps for selected Lab
    getProcessStepsByLab(lab:LabMDM, active: boolean): Observable<BBResponseContainer> {
        let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/carrier/state';
        let requestParam = new HttpParams().set('labId', lab._id).set('active', active.toString());
        const options = url ? { params: requestParam } : {};
        return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout),tap(event => { 
            console.log(event)
        }, error => {
            error.url = url;
        }));
    }
}

